import { fetchMerchants } from 'api/merchants';
import DebounceSelect from 'components/Select/DebounceSelect';
import React from 'react';
import { captureException } from 'utils/errors';

function MerchantInput({ value, ...props }) {
  const getMerchants = (search = '') => fetchMerchants({ search })
    .then((res) => {
      if (res.status === 'success') {
        const fetchedMerchants = res.data.results?.map((m) => ({
          label: m.name, value: m.id, merchant: m,
        }));
        return fetchedMerchants;
      }
    })
    .catch((e) => {
      captureException(e);
    });

  return (
    <DebounceSelect
      allowClear
      fetchOptions={getMerchants}
      value={value}
      showSearch
      {...props}
    />
  );
}
export default MerchantInput;
